// extracted by mini-css-extract-plugin
export default {"imageWrapper":"p0-z","hovered":"q0-z","hoverImage":"r0-z","mainImage":"s0-z","imageNoBackground":"t0-z","fullSizeImage":"u0-z"};